module.exports = __webpack_public_path__ + "media/images/credit_cards/Diners_Club-7fee9f55e8d5a83f7ac38eb2c7418321.png";